export default "__VITE_ASSET__BrxzqAZZ__"